import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MultiSelect } from 'react-selectize';
import './styles.css';
import { Badge } from 'react-bootstrap';
import firebase from 'firebase';
import { nanoid } from 'nanoid';

const Multiselect = ({ placeholder, className, onChange }) => {
    const selectRef = useRef(null);
    const selectedValues = useRef([]);
    const [_, needRefresh] = useState(nanoid());

    const handleValueChange = useCallback(
        values => {
            selectedValues.current = values;
            const newEmail = values[values.length - 1].value;
            firebase
                .firestore()
                .collection('users')
                .where('email', '==', newEmail)
                .get()
                .then(snap => {
                    if (snap.size > 0) {
                        const values = selectedValues.current.map(v =>
                            v.value === newEmail ? { ...v, value: '' } : v
                        );
                        selectRef.current.state.values = values;
                        selectedValues.current = values;
                        needRefresh(nanoid());
                        onChange(values);
                    }
                });
            needRefresh(nanoid());
            onChange(values);
        },
        [onChange]
    );

    const handleInputChange = useCallback((options, values, search) => {
        let labels = values.map(function (value) {
            return value.label;
        });
        if (search.trim().length === 0 || labels.indexOf(search.trim()) !== -1) return null;
        return { label: search.trim(), value: search.trim() };
    }, []);

    const handleValueRemove = useCallback(
        label => () => {
            const values = selectedValues.current.filter(v => v.label !== label);
            selectRef.current.state.values = values;
            selectedValues.current = values;
            onChange(values);
            needRefresh(nanoid());
        },
        []
    );

    const renderSelectValue = useCallback(
        ({ label, value }) => {
            return (
                <div
                    className={classNames('simple-value', {
                        disabled: !value,
                    })}
                >
                    <p>{label}</p>
                    <Badge color="primary" onClick={handleValueRemove(label)} pill>
                        x
                    </Badge>
                </div>
            );
        },
        [handleValueRemove]
    );

    return (
        <div>
            <MultiSelect
                ref={selectRef}
                className={classNames('c-multiselect', {
                    [className]: !!className,
                })}
                delimiters={[188, 32, 13]}
                placeholder={placeholder}
                restoreOnBackspace={item => item.label}
                renderValue={renderSelectValue}
                onValuesChange={handleValueChange}
                createFromSearch={handleInputChange}
            />
        </div>
    );
};

Multiselect.propTypes = {
    placeholder: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default React.memo(Multiselect);
